export default (value, nbZeros) => String(value).padStart(nbZeros, '0');
